import { render } from "./OnboardingStep2.vue?vue&type=template&id=04a6bb24"
import script from "./OnboardingStep2.vue?vue&type=script&lang=js"
export * from "./OnboardingStep2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__